import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext.jsx';
import '../styles/screens.css';

/**
 * You — profile & sign-out.
 *
 * Shows the authenticated user's name (from auth.user_metadata) and
 * email. The "Sign out" button calls supabase.auth.signOut, which
 * triggers AuthContext's onAuthStateChange listener and bounces the
 * user back to /signin via the App.jsx auth gate.
 */
export default function You() {
  const { user, signOut } = useAuth();
  const [signingOut, setSigningOut] = useState(false);

  const name = user?.user_metadata?.name || user?.email || 'You';
  const email = user?.email || '';
  const initials = name
    .split(' ')
    .map((s) => s[0] || '')
    .join('')
    .slice(0, 2)
    .toUpperCase();

  async function handleSignOut() {
    setSigningOut(true);
    await signOut();
    // No need to navigate — the auth gate in App.jsx will redirect
    // to /signin automatically once the session clears.
  }

  return (
    <div className="screen">
      <header className="screen-head">
        <div className="screen-head-text">
          <span className="eyebrow">Profile</span>
          <h1>
            <em>You</em>
          </h1>
        </div>
        <div className="avatar">{initials || 'YO'}</div>
      </header>

      <div className="card" style={{ marginBottom: 'var(--space-4)' }}>
        <div style={{ marginBottom: 'var(--space-3)' }}>
          <span className="eyebrow" style={{ display: 'block', fontSize: '0.65rem' }}>
            Name
          </span>
          <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>{name}</span>
        </div>
        <div>
          <span className="eyebrow" style={{ display: 'block', fontSize: '0.65rem' }}>
            Email
          </span>
          <span style={{ fontSize: '0.95rem' }}>{email}</span>
        </div>
      </div>

      <button
        className="btn btn-secondary"
        type="button"
        style={{ width: '100%', marginBottom: 'var(--space-3)' }}
        onClick={handleSignOut}
        disabled={signingOut}
      >
        {signingOut ? 'Signing out…' : 'Sign out'}
      </button>

      <p
        style={{
          textAlign: 'center',
          fontSize: '0.75rem',
          color: 'var(--muted)',
          marginTop: 'var(--space-6)',
        }}
      >
        © 2026 McEachern &amp; Associates Consulting Inc.<br />
        v0.1.0
      </p>
    </div>
  );
}
